export function openWhatsApp() {
  window.dispatchEvent(new Event('open-whatsapp'));
}
